import Vue from 'vue';
import Vuetify from 'vuetify/lib'
// import 'vuetify/dist/vuetify.min.css';
import zhHant from 'vuetify/lib/locale/zh-Hant';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    // options: { customProperties: true },
    dark: true,
    themes: {
      dark: {
        doctor: '#009fa5',
        normal: '#ef6357',
        primary: '#fff',
        secondary: '#424242',
        accent: '#8c9eff',
        error: '#d8374d',
        success: '#4CAF50',
        warning: '#da8200',
        // base: string
        // lighten5: string
        // lighten4: string
        // lighten3: string
        // lighten2: string
        // lighten1: string
        'drcell': '#3fc799',
        'error-darken': '#3a2225',
        'v-light': '#eee',
        'v-dark': '#242526',
        'v-dark2': '#161616',
        'grey-1': '#5b5b5b',
        'color-1': '#d6545c',
        'color-2': '#f98068',
        'color-3': '#f0c158',
        'color-4': '#98cb69',
        'color-5': '#00b69e',

        'pain-1': '#00b69e',
        'pain-2': '#98cb69',
        'pain-3': '#f0c158',
        'pain-4': '#f98068',
        'pain-5': '#d6545c',

        'level-1': '#49954c',
        'level-2': '#fff',
        'level-3': '#f0c158',
        'level-4': '#d6545c',

        'level-reverse-2': '#f0c158',
        'level-reverse-1': '#d6545c',

        'mark-warning': '#634d1e',
        'mark-danger': '#4a161e',

        'epro-basic': '#143b71',
        'epro-core': '#c4a215',

        'real-reply': '#ffdd73',
      }
    },
  },
  lang: {
    locales: { zhHant },
    current: 'zhHant',
  },
});
